module.exports = __webpack_public_path__ + "img/popup_business_pay_select.2f5d187b.png";